import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CurrentUserService } from '@/app/common/current-user/current-user.service';
import { SparkAdBudgetMode } from '@/app/common/general-types/tiktok-spark-ads.dto';
import { CreateSparkCampaign } from '../../../../service/create-spark-campaign/create-spark-campaign';

@Component({
  selector: 'cad-group-budget-schedule',
  imports: [],
  templateUrl: './group-budget-schedule.html',
  styleUrl: './group-budget-schedule.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroupBudgetSchedule {
  expanded = signal<boolean>(true);

  readonly budgetModes: ReadonlyArray<{ value: SparkAdBudgetMode; label: string }> = [
    { value: 'BUDGET_MODE_DAY', label: 'Daily' },
    { value: 'BUDGET_MODE_TOTAL', label: 'Lifetime' },
  ];

  public createSparkCampaignService = inject(CreateSparkCampaign);
  private currentUserService = inject(CurrentUserService);

  businessCurrencyCode(): string {
    const code = this.currentUserService.focussedBrand?.currencyCode;
    return typeof code === 'string' && code.trim().length > 0 ? code.trim().toUpperCase() : 'USD';
  }

  onBudgetModeSelected(mode: SparkAdBudgetMode): void {
    this.createSparkCampaignService.selectedBudgetModeAdGroup.set(mode);
  }

  isBudgetModeSelected(mode: SparkAdBudgetMode): boolean {
    return this.createSparkCampaignService.selectedBudgetModeAdGroup() === mode;
  }

  budgetModeLabel(mode: SparkAdBudgetMode | undefined): string {
    if (!mode) {
      return '';
    }
    const row = this.budgetModes.find((m) => m.value === mode);
    return row?.label ?? mode;
  }

  onBudgetInput(event: Event): void {
    const raw = (event.target as HTMLInputElement).value;
    if (raw === '') {
      this.createSparkCampaignService.budgetAdGroup.set(0);
      return;
    }
    const n = parseFloat(raw);
    this.createSparkCampaignService.budgetAdGroup.set(Number.isFinite(n) ? n : 0);
  }

  onStartDateInput(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.createSparkCampaignService.startDateAdGroup.set(value);
  }

  onEndDateInput(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.createSparkCampaignService.endDateAdGroup.set(value);
  }
}
